import { useClub } from "@/hooks/useClub";
import type { ClubSections } from "@/lib/types";
import Hero from "./components/Hero";
import LadderBanner from "./components/LadderBanner";
import TreatSection from "./components/TreatSection";
import RpsSection from "./components/RpsSection";
import TugSection from "./components/TugSection";
import ScheduleHomeSection from "./components/ScheduleHomeSection";
import IntroSection from "./components/IntroSection";
import OrgSection from "./components/OrgSection";
import RuleSection from "./components/RuleSection";
import BizmapPreview from "./components/BizmapPreview";
import CardSection from "./components/CardSection";
import PromoSection from "./components/PromoSection";
import NoticeSection from "./components/NoticeSection";
import GallerySection from "./components/GallerySection";
import FreeSection from "./components/FreeSection";
import VoteSection from "./components/VoteSection";
import ClubAccountSection from "./components/ClubAccountSection";
import PopupModal from "./components/PopupModal";

// 섹션 노출 스위치 판정.
// - sections 자체가 없으면 전부 켜진 것으로 간주한다.
// - 값이 0 이면 꺼진 것으로 보고 컴포넌트를 렌더링하지 않는다(흔적 없음).
function sectionOn(sections: ClubSections | undefined, key: keyof ClubSections): boolean {
  if (!sections) return true;
  return Number(sections[key] ?? 1) !== 0;
}

export default function Home() {
  const { club, loading: clubLoading } = useClub();
  const sections = club?.sections;

  return (
    <>
      {sectionOn(sections, "ladder") && <LadderBanner />}
      <Hero club={club} />
      {sectionOn(sections, "treat") && <TreatSection />}
      {sectionOn(sections, "rps") && <RpsSection />}
      {sectionOn(sections, "tug") && <TugSection />}
      {sectionOn(sections, "calendar") && <ScheduleHomeSection />}
      {sectionOn(sections, "intro") && (
        <IntroSection club={club} loading={clubLoading} />
      )}
      {sectionOn(sections, "org") && <OrgSection />}
      {sectionOn(sections, "rules") && <RuleSection />}
      {sectionOn(sections, "card") && <CardSection />}
      {sectionOn(sections, "bizmap") && <BizmapPreview />}
      {sectionOn(sections, "promo") && <PromoSection />}
      {sectionOn(sections, "gallery") && <GallerySection />}
      {sectionOn(sections, "free") && <FreeSection />}
      {sectionOn(sections, "vote") && <VoteSection />}
      {sectionOn(sections, "notice") && <NoticeSection />}
      {sectionOn(sections, "account") && <ClubAccountSection club={club} />}
      <PopupModal popups={club?.popup ?? []} />
    </>
  );
}